import { cadenceLabel, describeDiscount } from "../../shared/billing-labels";
import { formatUsd, summarizeTotals } from "../../shared/billing-money";

/** Rendering helpers shared by the billing screens (ADR-0073). Pure, so they are tested once. */

export function formatDay(seconds: number | null): string {
  return seconds === null ? "—" : new Date(seconds * 1_000).toISOString().slice(0, 10);
}

/** `YYYY-MM-DD` from a date input → seconds at UTC midnight, or null when empty or malformed. */
export function dayToSeconds(value: string): number | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) return null;
  const seconds = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])) / 1_000;
  return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
}

/** The last second of a `YYYY-MM-DD` day, in UTC: "the customer can accept until the end of this day". */
export function endOfDay(day: string): number | null {
  const start = dayToSeconds(day);
  return start === null ? null : start + 86_400 - 1;
}

export { cadenceLabel, describeDiscount, formatUsd, summarizeTotals };
